import clsx from 'clsx'

import styles from './about-transaction.module.scss'

export const AboutTransaction = () => {
    return (
        <div className={styles['about-transaction']}>
            <div className={styles['about-transaction__status']}>
                <span className={styles['about-transaction__status--title']}>
                    Деньги поступят через 3 ч 59 м
                </span>
                <span className={styles['about-transaction__status--description']}>
                    Проверяем заказ
                </span>
            </div>
            <div className={styles['about-transaction-details']}>
                <div className={styles['about-transaction-main']}>
                    <span className={styles['about-transaction-main__date']}>Сегодня в 14:32</span>
                    <div className={styles['about-transaction-main__income']}>
                        <span className={styles['about-transaction-main__income--title']}>
                            Доход с заказа
                        </span>
                        <span className={styles['about-transaction-main__income--amount']}>
                            +300,12 ₽
                        </span>
                    </div>
                    <div className={styles['about-transaction-main__income']}>
                        <span className={styles['about-transaction-main__income--title']}>
                            Доход с заказа
                        </span>
                        <span
                            className={clsx(
                                styles['about-transaction-main__income--amount'],
                                styles['about-transaction-main__income--amount--positive'],
                            )}
                        >
                            +300,12 ₽
                        </span>
                    </div>
                    <div className={styles['about-transaction-main__income']}>
                        <span className={styles['about-transaction-main__income--title']}>
                            Доход с заказа
                        </span>
                        <span
                            className={clsx(
                                styles['about-transaction-main__income--amount'],
                                styles['about-transaction-main__income--amount--processing'],
                            )}
                        >
                            +300,12 ₽
                        </span>
                    </div>
                </div>
                <div className={styles['about-transaction-additional']}>
                    <div className={styles['about-transaction-additional__item']}>
                        <span>Стоимость поездки</span>
                        <span>250 ₽</span>
                    </div>
                    <div className={styles['about-transaction-additional__item']}>
                        <span>Компенсация за ожидание</span>
                        <span>+50 ₽</span>
                    </div>
                </div>
                <div className={styles['about-transaction-commission']}>
                    <div className={styles['about-transaction-commission__summary']}>
                        <span>Итоговая до вычета</span>
                        <span>300 ₽</span>
                    </div>
                    <span className={styles['about-transaction-commission__text']}>
                        Платёж Drivee — 10 ₽
                    </span>
                    <span className={styles['about-transaction-commission__text']}>НДС — 5 ₽</span>
                    <span className={styles['about-transaction-commission__text']}>
                        Комиссия $service_name$ — 4 ₽
                    </span>
                </div>
            </div>
            <div className={styles['about-transaction-points']}>
                <div className={styles['about-transaction-points__item']}>
                    <span className={styles['about-transaction-points__item--title']}>Начало </span>
                    <span className={styles['about-transaction-points__item--value']}>
                        Психоневралогический диспансер (улица Котенко, 14 Якутск)
                    </span>
                </div>
                <div className={styles['about-transaction-points__item']}>
                    <span className={styles['about-transaction-points__item--title']}>
                        Промежуточная точка
                    </span>
                    <span className={styles['about-transaction-points__item--value']}>
                        Наркологический диспансер (улица Богдана Чижика, 33/2)
                    </span>
                </div>
                <div className={styles['about-transaction-points__item']}>
                    <span className={styles['about-transaction-points__item--title']}>Конец</span>
                    <span className={styles['about-transaction-points__item--value']}>
                        ПивоRooB (улица Богдана Чижика, 33д)
                    </span>
                </div>
            </div>
            <span className={styles['about-transaction__card']}>На карту **** 2313</span>
        </div>
    )
}
